import { createFileRoute } from '@tanstack/react-router';
import UserLayout from '@components/layout/UserLayout.tsx';
import SearchComponent from '@features/search/comp/SearchComponent.tsx';
import { z } from 'zod';

const searchSchema = z.object({
  q: z.coerce.string(),
  selectedSupplierIds: z.array(z.coerce.number()).optional(),
  categoryEcid: z.coerce.string().optional(),
  sort: z.enum(['relevance', 'name-asc', 'name-desc', 'price-asc', 'price-desc']).optional(),
  priceFilter: z.enum(['standard', 'alternative', 'sales', 'delivery']).optional(),
  isGuaranteed: z.coerce.boolean().optional(),
});

export const Route = createFileRoute('/c/$orgId/$portalId/search')({
  validateSearch: v => searchSchema.parse(v),
  component: RouteComponent,
});

function RouteComponent() {
  const query = Route.useSearch().q;

  return (
    <UserLayout>
      <SearchComponent query={query} />
    </UserLayout>
  );
}
